export default "__VITE_ASSET__CknmS1q2__"